export default __webpack_public_path__ + "static/media/JP3-1.c1d15f45.jpg";